import { MaterializedCategoryCollectionCard } from '@fagmobler/sanity';
import CategoryCard from './CategoryCard';

export type CategoryCollectionCardProps = MaterializedCategoryCollectionCard & {
  getHref(algoliaProductCategorySlug: string): string;
};

export const CategoryCollectionCard = ({
  categories = [],
  getHref,
}: CategoryCollectionCardProps) => {
  return (
    <div className="grid gap-5 grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      {categories.map((category) => {
        if (!category.productCategoryEnrichment) return null;
        const algoliaProductCategorySlug =
          category.productCategoryEnrichment.algoliaProductCategorySlug;
        const href =
          algoliaProductCategorySlug && getHref(algoliaProductCategorySlug);
        return (
          <CategoryCard
            {...category}
            imageUrl={category.productCategoryEnrichment?.icon?.asset?.url}
            href={href}
            key={category.productCategoryEnrichment._id}
          />
        );
      })}
    </div>
  );
};

export default CategoryCollectionCard;
